/**
 * Base URL for the pro-settings endpoints.
 *
 * These live in their own `pro_settings` database on the API side, and only the
 * staging API has it populated — hence the staging default. The value used to be
 * hardcoded at every call site, which meant the host could only be changed by
 * shipping a new build; `NEXT_PUBLIC_PRO_SETTINGS_API_URL` makes it an env knob
 * (e.g. to point at production once the data is migrated there).
 */
export const PRO_SETTINGS_API_URL = process.env.NEXT_PUBLIC_PRO_SETTINGS_API_URL || 'https://staging-api.noping.com/api/v1';
